module.exports = __webpack_public_path__ + "resources/images/dashboard_new-4f87e01ce4d3e9eb27dc96bb736da798-cache.png";